import { Expose } from "class-transformer";
import { CreateOnCallTypeDto } from "@/core/features/on-call-types/create-on-call-type.dto";

export class UpdateOnCallTypeDto extends CreateOnCallTypeDto {
  @Expose()
  id: string;
}
